export class CoverageIterationMissionUiState {
            
    public showResult:boolean    
    public timelineIndex:number
    public sciHoverData:any
    public navHoverData:any
    public simuHoverData:any

    constructor({                
                showResult = false, 
                sciHoverData=null,
                navHoverData=null,
                simuHoverData=null,
                timelineIndex = -1
            } = {}) {  
        this.showResult = showResult
        this.timelineIndex = timelineIndex
        this.sciHoverData = sciHoverData        
        this.navHoverData = navHoverData        
        this.simuHoverData = simuHoverData
    }
} 

export const buildCoverageIterationMissionUiStateId = (covItUiid:string, glider:string) => {
    return `${covItUiid}_${glider}`
}